module.exports = __webpack_public_path__ + "img/email-2.6091ac02.svg";